import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { toast } from "react-toastify";

const navStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  :root {
    --g1: #2e4a1a;
    --g2: #3d6622;
  }

  *{
    box-sizing:border-box;
  }

  /* NAVBAR */
  .nav {
    height: 78px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 70px;
    background: #fff;
    border-bottom: 1px solid #eaeaea;
    position: sticky;
    top: 0;
    z-index: 200;
  }

  /* Logo */
  .nav-brand {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .nav-brand img {
    width: 220px;
    height: auto;
    object-fit: contain;
  }

  /* Right Side */
  .nav-right {
    display: flex;
    align-items: center;
    gap: 35px;
  }

  /* Links */
  .nav-links {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-links li a {
    text-decoration: none;
    font-size: 17px;
    font-weight: 600;
    color: #1e1e1e;
    transition: 0.3s ease;
  }

  .nav-links li a:hover {
    color: var(--g2);
  }

  /* Button */
  .nav-cta {
    background: var(--g1);
    color: #fff;
    border: none;
    outline: none;
    padding: 14px 28px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .nav-cta:hover {
    background: var(--g2);
    transform: translateY(-1px);
  }

  /* Logout Button */
  .nav-logout {
    background: transparent;
    color: #c0392b;
    border: 2px solid #c0392b;
    outline: none;
    padding: 12px 26px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .nav-logout:hover {
    background: #c0392b;
    color: #fff;
    transform: translateY(-1px);
  }

  /* Responsive */
  @media (max-width: 768px) {
    .nav {
      padding: 0 20px;
      height: 72px;
    }

    .nav-brand img {
      width: 170px;
    }

    .nav-right {
      gap: 18px;
    }

    .nav-links li a {
      font-size: 15px;
    }

    .nav-cta, .nav-logout {
      padding: 12px 18px;
      font-size: 14px;
    }
  }
`;

export default function Navbar() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check token on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    toast.success("Logout successful");
    navigate("/");
  };

  return (
    <>
      <style>{navStyles}</style>

      <nav className="nav">
        {/* Logo */}
        <div className="nav-brand" onClick={() => navigate("/")}>
          <img src="/images/imt.png" alt="imTransporter" />
        </div>

        {/* Right Section */}
        <div className="nav-right">
          <ul className="nav-links">
            <li>
              <a href="/">Enterprise</a>
            </li>
          </ul>

          {isLoggedIn ? (
            <button className="nav-cta" onClick={handleLogout}>
              Log Out
            </button>
          ) : (
            <button className="nav-cta" onClick={() => navigate('/login')}>
              Get Started
            </button>
          )}
        </div>
      </nav>
    </>
  );
}